import React from "react";
import { ListGroup } from "react-bootstrap";
import LinkImg from "../../../../../assets/images/link-dedicado.jpg";

import './styles.css';


const LinkDedicado = () => {
    return (
        <div className="container">
            <div className="row">
                <div>
                    <h2>Publique seus servidores diretamente na internet por meio do nosso link dedicado com IP público fixo.</h2>
                </div>
                <div className="col-sm-12 col-md-6">
                    <img src={LinkImg} alt="foto"></img>
                    <p>                        
                        Com essa solução, nosso cliente terá a capacidade de disponibilizar seus serviços online de forma direta,
                        permitindo que seus clientes acessem seus sites, aplicativos e conteúdos hospedados em seus
                        servidores sem intermediações.<br /> Através de um IP público fixo, garantimos a estabilidade e
                        confiabilidade necessárias para uma presença online eficiente e de alto desempenho.
                    </p>
                </div>
                <div className="col-sm-12 col-md-6">
                    <ListGroup>
                        <ListGroup.Item>
                            1. Conexão exclusiva: Com um link dedicado, você terá uma conexão exclusiva de internet, garantindo alta velocidade e estabilidade, sem compartilhar a largura de banda com outros usuários.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            2. Alta velocidade: Os links dedicados oferecem velocidades de internet superiores, ideais para transferência rápida de dados, videoconferências de qualidade e acesso remoto a servidores.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            3. Download e Upload: A mesma velocidade contratada para download também se aplica ao upload. Por exemplo,
                            se você contratar um link de 100 MEGAS, terá a mesma velocidade tanto para baixar quanto para
                            enviar arquivos.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            4. Confiabilidade: Com um link dedicado, sua empresa terá uma conexão confiável e de alta disponibilidade, garantindo que suas operações ocorram sem interrupções.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            5. IPs públicos fixos: Com um link dedicado, você terá 5 IPs públicos fixos, permitindo maior flexibilidade e facilidade de acesso aos recursos da sua rede.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            6. Suporte técnico especializado: Conte com um plantão de suporte técnico especializado 24 horas por dia, 7 dias por semana, para resolver qualquer eventualidade e garantir o máximo desempenho da sua conexão.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            7. Servidores diretamente na internet por meio do nosso Link Dedicado. Tenha toda infraestrutura digital sobre seu domínio sem intermediações.
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            </div>
        </div>
    );
}
export default LinkDedicado;